import { Card, Col, Container, Row, Spinner } from "react-bootstrap";
import "./documentList.css";
import { useEffect, useState } from "react";
import { Document, Criteria, DocumentSortMethod } from "../../models/document";
import apiService from "../../services/ApiService";
import Constants from "../../helpers/Constants";
import { useParams } from "react-router-dom";
import PaginationPanel from "../../components/paginations/paginationPanel";
import AppSettings from "../../configs/appSettings";
import { FaSearch } from "react-icons/fa";
import SortingDropdown from "../../components/dropdowns/documents/sortMethod/sortMethodDropDown";
import  { useDebounce }  from "../../Utils/index";

const DocumentGroup = () => {
  const { category } = useParams();
  const initPageData: Document = {
    files: [],
    itemCount: 0,
    pageCount: 0,
    category: { name: "", description: "" },
  };
  const [pageData, setPageData] = useState(initPageData);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword,setSearchKeyword]=useState("");
  const [sortedMethod,setSortedMethod]= useState(Object.keys(DocumentSortMethod).indexOf(DocumentSortMethod.MostRecent.replace(' ','')))
  

  const handleSearchBarChange=(val:string)=>{
    if(!!val) setSearchKeyword(val);
  }
  const handleSortOptionChange=(val:DocumentSortMethod)=>{
    setSortedMethod(Object.keys(DocumentSortMethod).indexOf(val.replaceAll(' ','')));
   
  }

  const decounceSearchValue = useDebounce(searchKeyword,2000);

  useEffect(() => {

    const criteria: Criteria = {
      keyword: decounceSearchValue,
      category: category ?? "logos",
      page: page,
      sku: "",
      display: "group",
      sortMethod: sortedMethod
    };
    apiService
      .get(`${Constants.ApiPath.DocumentPage}`, criteria)
      .then((result) => {
        if (result) {
          setIsLoading(false);
          setPageData(result.data);
        }
      });
  }, [category, page,decounceSearchValue,sortedMethod]);
  const handlePageIndexChange = (value: number) => {
    setPageData((prevValue) => {
      return { ...prevValue, files: [] };
    });
    setPage(value);
  };
  const handleDownloadFile = (id: string) => {
    const ids = [id];
    apiService
      .get(
        Constants.ApiPath.DocumentGenerate,
        { ids },
        { Accept: "text/plain" }
      )
      .then((result) => {
        const url = `${AppSettings.ApiBaseUrl}/${
          Constants.ApiPath.DocumentDownload
        }?code=${encodeURIComponent(result.data)}`;
        window.location.href = url;
      });
  };  




  return isLoading ? (
    <Container className="category-page-loading">
      <div>
        <Spinner animation="border" />
        <p>Loading...</p>
      </div>
    </Container>
  ) : (
    <>
      <Container className="document-page-header">
        <label>{pageData.category.name}</label>
      <Row className="pt-3">
      <div className="col-3">
          <div className="round-search-input">
            <FaSearch color="white" className="icon" />
            <input
              type="text"
              placeholder="Document Name"
              onChange={(e) => handleSearchBarChange(e.target.value)}
            />
          </div>
        </div>       
        <span className="col-1 pt-1 text-end"><strong>Sort By</strong></span>
        <div className="col-3">        
          <SortingDropdown selectedValue={Object.values(DocumentSortMethod)[sortedMethod]} onSelected={handleSortOptionChange}>
          </SortingDropdown>
        </div>
      </Row>
      </Container>
      <Container className="document-page-list">
        <Row className="d-flex justify-content-start flex-wrap">
          {pageData.files.map((document, idx) => {
            return (
              <Col key={idx} className="docuemnt-page-group-col">
                <Card className="document-page-thumbnail">
                  <Card.Img src={document.thumbnail} title={document.name} onClick={() => handleDownloadFile(document.id)} />
                </Card>
                <label onClick={() => handleDownloadFile(document.id)}>{document.name}</label>
              </Col>
            );
          })}
        </Row>
      </Container>
      <Container className="document-page-pagination-container">
        <PaginationPanel
          pageCount={pageData.pageCount}
          pageIndex={page}
          onPageIndexChange={(val) => handlePageIndexChange(val)}
        />
      </Container>
      <Container className="document-page-header">
        <span>{pageData.category.description}</span>
      </Container>

    </>
  );
};

export default DocumentGroup;
